import userReducer from "@material-dev/insights-portal-ui-components/lib/slices/user/userSlice";
import UserState from "@material-dev/insights-portal-ui-components/lib/slices/user/UserState";
import { combineReducers } from "redux";
import assignersSlice from "./assigners/assignersSlice";
import { AssignersState } from "./assigners/assignersState";
import batteriesSlice from "./batteries/batteriesSlice";
import { BatteriesState } from "./batteries/batteriesState";
import batterySlice from "./battery/batterySlice";
import { BatteryState } from "./battery/batteryState";
import brandsSlice from "./brands/brandsSlice";
import { BrandsState } from "./brands/brandsState";
import compareVersionSlice from "./compareVersions/compareVersionsSlice";
import { CompareVersionState } from "./compareVersions/compareVersionsState";
import dashboardSlice from "./dashboard/dashboardSlice";
import { DashboardState } from "./dashboard/dashboardState";
import textVariablesSlice from "./textVariablesProject/textVariablesSlice";
import { TextVariablesState } from "./textVariablesProject/textVariablesState";
import encodingFilesSlice from "./encodingFiles/encodingFilesSlice";
import EncodingFileState from "./encodingFiles/encodingFilesState"; 
import excludedVariablesSlice from "./excludedVariables/excludedVariablesSlice";
import { ExcludedVariablesState } from "./excludedVariables/excludedVariablesState";
import forstaProjectSlice from "./forstaProject/forstaProjectSlice";
import { ForstaProjectState } from "./forstaProject/forstaProjectState";
import importInstructionSlice from "./importInstructions/ImportInstructionSlice";
import { ImportInstructionState } from "./importInstructions/ImportInstructionState";
import instructionsReducer from "./instructions/instructionsSlice";
import { InstructionsState } from "./instructions/instructionsState";
import modificationFiltersSlice from "./modificationFilters/modificationFilterSlice";
import { ModificationFiltersState } from "./modificationFilters/modificationFiltersState";
import modificationsSlice from "./modifications/modificationsSlice";
import { ModificationsState } from "./modifications/modificationsState";
import modificationStacksSlice from "./modificationStacks/modificationStacksSlice";
import { ModificationStacksState } from "./modificationStacks/modificationStacksState";
import modificationStackValidationSlice from "./modificationStackValidation/modificationStackValidationSlice";
import { ModificationStackValidationState } from "./modificationStackValidation/modificationStackValidationState";
import originProjectReducer from "./originProjects/originProjectSlice";
import OriginProjectState from "./originProjects/originProjectState";
import powerBIProjectSlice from "./powerBIProject/powerBIProjectSlice";
import { PowerBIProjectState } from "./powerBIProject/powerBIProjectState";
import projectReducer from "./project/projectSlice";
import { ProjectState } from "./project/projectState";
import projectEncodingVersionSlice from "./projectEncodingVersion/projectEncodingVersionSlice";
import { ProjectEncodingVersionState } from "./projectEncodingVersion/projectEncodingVersionState";
import projectsReducer from "./projects/projectsSlice";
import { ProjectsState } from "./projects/projectsState";
import projectsDataReducer from "./projectsData/projectsDataSlice";
import ProjectsDataState from "./projectsData/projectsDataState";
import DatasetsReducer from "./datasets/datasetsSlice";
import DatasetsState from "./datasets/datasetsState";
import projectSelectorSlice from "./projectSelector/projectSelectorSlice";
import { ProjectSelectorState } from "./projectSelector/projectSelectorState";
import projectSourcesReducer from "./projectSources/projectSourcesSlice";
import { ProjectSourcesState } from "./projectSources/projectSourcesState";
import recodeSlice from "./recode/recodeSlice";
import { RecodeState } from "./recode/recodeState";
import similarityReportSlice from "./similarityReport/similarityReportSlice";
import { SimilarityReportState } from "./similarityReport/similarityReportState";
import stemsSlice from "./stems/stemsSlice";
import { StemsState } from "./stems/stemsState";
import variablesSlice from "./variables/variablesSlice";
import { VariablesState } from "./variables/variablesState";
import variableStatsSlice from "./variableStats/variableStatsSlice";
import { VariableStatsState } from "./variableStats/variableStatsState";
import rOriginProjectSlice from "./rOriginProject/rOriginProjectSlice";
import { ROriginProjectState } from "./rOriginProject/rOriginProjectState";
import reportsSlice from "./reports/reportsSlice";
import { ReportsState } from "./reports/reportsState";
import compositeProjectSlice from "./compositeProject/compositeProjectSlice";
import { CompositeProjectState } from "./compositeProject/compositeProjectState";
import stackablesSlice from "./stackables/stackablesSlice";
import { StackablesState } from "./stackables/stackablesState";
import projectIntegrationsSlice from "./projectIntegrations/projectIntegrationsSlice";
import { ProjectIntegrationsState } from "./projectIntegrations/projectIntegrationsState";
import openEndVariablesSlice from "./openEndVariables/openEndVariablesSlice";
import oeCodingSlice from "./oeCoding/oeCodingSlice";
import customDataProjectSlice from "./customDataProject/customDataProjectSlice";
import languageVariableSlice from "./languageVariable/languageVariableSlice";
import { CustomDataProjectState } from "./customDataProject/customDataProjectState";
import workdayProjectSlice from "./WorkdayProjects/workdayProjectSlice";
import { WorkdayProjectState } from "./WorkdayProjects/workdayProjectState";
import relevancyCheckerSlice from "./relevancyChecker/relevancyCheckerSlice";
import { RelevancyCheckerState } from "./relevancyChecker/relevancyCheckerState";
import { TranslateState } from "./translate/translateState";
import translateSlice from "./translate/translateSlice";
import { WorkdayProjectDatasetState } from "./workdayProjectDataset/workdayProjectDatasetState";
import workdayProjectDatasetSlice from "./workdayProjectDataset/workdayProjectDatasetSlice";
import workdayProjectDatasetsSlice from "./workdayProjectDatasets/workdayProjectDatasetsSlice";
import { WorkdayProjectDatasetsState } from "./workdayProjectDatasets/workdayProjectDatasetsState";
import walrProjectSlice from "./WalrProjects/walrProjectSlice";
import { WalrIntegrationHistoryState } from "./walrIntegrationHistory/walrIntegrationHistoryState";
import walrIntegrationHistorySlice from "./walrIntegrationHistory/walrIntegrationHistorySlice";
import { UnslotVariablesState } from "./unslotVariables/unslotVariablesState";
import unslotVariablesSlice from "./unslotVariables/unslotVariablesSlice";
import { InteractionLogState } from "./InteractionLogs/InteractionLogsState";
import interactionLogSlice from "./InteractionLogs/InteractionLogsSlice";
import { RelabeledVariablesState } from "./relabeledVariables/relabeledVariablesState";
import relabeledVariablesSlice from "./relabeledVariables/relabeledVariablesSlice";
import { DownloadTextVariablesState } from "./downloadTextVariables/downloadTextVariablesState";
import downloadTextVariablesSlice from "./downloadTextVariables/downloadTextVariablesSlice";
import { AICodingState } from "./aiCoding/aiCodingState";
import aiCodingSlice from "./aiCoding/aiCodingSlice";
import chatbotSlice from "./chatbot/chatbotSlice";
import { ChatbotState } from "./chatbot/chatbotState";
import projectHeatmapSettingsSlice from "./projectHeatmapSettings/projectHeatmapSettingsSlice";
import { ProjectHeatmapSettingsState } from "./projectHeatmapSettings/projectHeatmapSettingsState";

import selectedClicksRadiusSlice from "./selectedOptions/selectedClicksRadiusSlice";
import selectedClicksSlice from "./selectedOptions/selectedClicksSlice";
import selectedClusteringSlice from "./selectedOptions/selectedClusteringSlice";
import selectedFilterQuestionSlice from "./selectedOptions/selectedFilterQuestionSlice";
import selectedImageSlice from "./selectedOptions/selectedImageSlice";
import selectedQuestionsSlice from "./selectedOptions/selectedQuestionsSlice";
import selectedTransparencySlice from "./selectedOptions/selectedTransparencySlice";
import selectedWeightingVariableSlice from "./selectedOptions/selectedWeightingVariableSlice";
import { MaterializedPipelineState } from "./materializedPipeline/materializedPipelineState";
import materializedPipelineSlice from "./materializedPipeline/materializedPipelineSlice";

import generateHeatmapReportsSlice, {
  GenerateHeatmapReportState,
} from "./heatmapReport/generateHeatmapReportSlice";

import heatmapReportSettingsSlice, {
  HeatmapReportSettingsState,
} from "./heatmapReport/heatmapReportSettingsSlice";

import downloadReportSlice, {
  DownloadReportState,
} from "./heatmapReport/downloadReportSlice";

import { LoadingState } from "types";

export interface BaseState {
  processing: boolean;
  finished: boolean;
  succeed: boolean;
  failed: boolean;
  error: string;
}

export interface HeatmapBaseState {
  loading: LoadingState;
}

export interface PersistentState {
  isPersistent: boolean;
}

export interface IState {
  userState: UserState;
  projectsData: ProjectsDataState;
  originProjects: OriginProjectState;
  datasetsData: DatasetsState;
  rOriginProjects: ROriginProjectState;
  projectSources: ProjectSourcesState;
  encodingFiles: EncodingFileState;
  project: ProjectState;
  projects: ProjectsState; 
  projectEncodingVersion: ProjectEncodingVersionState;
  similarityReport: SimilarityReportState;
  variables: VariablesState;
  batteriesState: BatteriesState;
  modifications: ModificationsState;
  brands: BrandsState;
  assigners: AssignersState;
  modificationStacks: ModificationStacksState;
  stems: StemsState;
  modificationStackValidation: ModificationStackValidationState;
  battery: BatteryState;
  recode: RecodeState;
  instructions: InstructionsState;
  modificationFilters: ModificationFiltersState;
  compareVersions: CompareVersionState;
  projectSelector: ProjectSelectorState;
  forstaProject: ForstaProjectState;
  importInstructions: ImportInstructionState;
  variableStats: VariableStatsState;
  excludeVariables: ExcludedVariablesState;
  dashboard: DashboardState;
  powerBIProject: PowerBIProjectState;
  textVariables: TextVariablesState;
  generateHeatmapReport: GenerateHeatmapReportState;
  downloadReport: DownloadReportState;

  reports: ReportsState;

  compositeProject: CompositeProjectState;
  stackables: StackablesState;
  projectIntegrations: ProjectIntegrationsState;
  customDataProject: CustomDataProjectState;
  relevancyChecker: RelevancyCheckerState;
  workdayProject: WorkdayProjectState;
  translate: TranslateState;
  workdayProjectDataset: WorkdayProjectDatasetState;
  workdayProjectDatasets: WorkdayProjectDatasetsState;
  walrIntegrationHistory:WalrIntegrationHistoryState;
  unslotVariables:UnslotVariablesState;
  interactionLog:InteractionLogState;
  relabeledVariables: RelabeledVariablesState;
  downloadTextVariables: DownloadTextVariablesState;
  aiCoding: AICodingState;
  projectHeatmapSettings: ProjectHeatmapSettingsState;
  heatmapReportSettings: HeatmapReportSettingsState;
  chatbot: ChatbotState;
  materializedPipeline: MaterializedPipelineState;
}

const rootReducer = combineReducers({
  userState: userReducer,
  projectsData: projectsDataReducer,
  datasetsData: DatasetsReducer,
  originProjects: originProjectReducer,
  projectSources: projectSourcesReducer,
  encodingFiles: encodingFilesSlice,
  project: projectReducer,
  projectEncodingVersion: projectEncodingVersionSlice,
  projects: projectsReducer, 
  similarityReport: similarityReportSlice,
  variables: variablesSlice,
  batteries: batteriesSlice,
  modifications: modificationsSlice,
  brands: brandsSlice,
  assigners: assignersSlice,
  modificationStacks: modificationStacksSlice,
  stems: stemsSlice,
  modificationStackValidation: modificationStackValidationSlice,
  battery: batterySlice,
  recode: recodeSlice,
  instructions: instructionsReducer,
  modificationFilters: modificationFiltersSlice,
  compareVersions: compareVersionSlice,
  projectSelector: projectSelectorSlice,
  forstaProject: forstaProjectSlice,
  importInstructions: importInstructionSlice,
  variableStats: variableStatsSlice,
  excludeVariables: excludedVariablesSlice,
  dashboard: dashboardSlice,
  powerBIProject: powerBIProjectSlice,
  textVariables: textVariablesSlice,
  reports: reportsSlice,
  rOriginProjectSelector: rOriginProjectSlice,
  compositeProject: compositeProjectSlice,
  stackables: stackablesSlice,
  projectIntegrations: projectIntegrationsSlice,
  openEndVariables: openEndVariablesSlice,
  oeCoding: oeCodingSlice,
  customDataProject: customDataProjectSlice,
  languageVariable: languageVariableSlice,
  relevancyChecker: relevancyCheckerSlice,
  workdayProject: workdayProjectSlice,
  walrProject: walrProjectSlice,
  translate: translateSlice,
  workdayProjectDataset: workdayProjectDatasetSlice,
  workdayProjectDatasets: workdayProjectDatasetsSlice,
  walrIntegrationHistory: walrIntegrationHistorySlice,
  unslotVariables:unslotVariablesSlice,
  interactionLogs:interactionLogSlice,
  relabeledVariables: relabeledVariablesSlice,
  aiCoding: aiCodingSlice,
  downloadTextVariables: downloadTextVariablesSlice,
  chatbot: chatbotSlice,
  projectHeatmapSettings: projectHeatmapSettingsSlice,
  selectedClicks: selectedClicksSlice,
  selectedClicksRadius: selectedClicksRadiusSlice,
  selectedClustering: selectedClusteringSlice,
  selectedFilterQuestion: selectedFilterQuestionSlice,
  selectedImage: selectedImageSlice,
  selectedQuestions: selectedQuestionsSlice,
  selectedTransparency: selectedTransparencySlice,
  selectedWeightingVariable: selectedWeightingVariableSlice,
  generateHeatmapReports: generateHeatmapReportsSlice,
  heatmapReportSettings: heatmapReportSettingsSlice,
  reportSettings: reportsSlice,
  downloadReport: downloadReportSlice,
  materializedPipeline: materializedPipelineSlice,
});

export default rootReducer;
